import { render, staticRenderFns } from "./AscReportPlotsWrapper.vue?vue&type=template&id=4609c024&"
import script from "./AscReportPlotsWrapper.vue?vue&type=script&lang=js&"
export * from "./AscReportPlotsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscReportPlotsWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports